
import SectionContactV1 from '../../sections/general/contact/SectionContactV1'
import SectionContactV2 from '../../sections/general/contact/SectionContactV2'
export default {
  name: 'SectionContact',
  props: {
    variant: {
      required: true,
      type: String,
      default: ''
    },
    data: {
      required: true,
      type: Object | Array,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      componentVariant: null
    }
  },
  watch: {
    variant: function (newVariant, oldVariant) {
      this.handleVariant(newVariant)
    }
  },
  created() {
    this.handleVariant(this.variant)
  },
  methods: {
    handleVariant(variant) {
      switch (variant) {
        case 'v2':
          this.componentVariant = SectionContactV2
          break
        default:
          this.componentVariant = SectionContactV1
          break
      }
    }
  }
}
